'use client';

import { CalculatorId, CalculatorType, type CalculatorConfig } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { scatterChartConfig } from '../scatter-chart/scatter-chart.config';

export const xyPlotConfig: CalculatorConfig<CalculatorId.XYPlot> = {
  ...scatterChartConfig,
  id: CalculatorId.XYPlot,
  type: CalculatorType.Graph,
  name: 'XY Plot',
  initialData: TableDataJSON.from({
    columns: [
      { id: 'time', name: 'Time (s)', values: ['0', '1', '2', '3', '4', '5'] },
      { id: 'distance', name: 'Distance (m)', values: [
        '0.2',     // ~0 + noise
        '5.3',     // ~4.9 + noise
        '18.9',    // ~19.6 - noise
        '45.2',    // ~44.1 + noise
        '77.1',    // ~78.4 - noise
        '124.8'    // ~122.5 + noise
      ] }
    ]
  }),
  initialControlValues: {
    xColumn: 'time',
    yColumn: 'distance',
    title: 'Distance vs Time',
    markerSize: 8,
    trendlineType: 'none'
  }
}; 